/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The UserUpdateResponse model module.
 * @module model/UserUpdateResponse
 * @version v1
 */
export class UserUpdateResponse {
  /**
   * Constructs a new <code>UserUpdateResponse</code>.
   * @alias module:model/UserUpdateResponse
   * @class
   * @param status {String} 
   * @param account {Object} 
   */
  constructor(status, account) {
    this.status = status;
    this.account = account;
  }

  /**
   * Constructs a <code>UserUpdateResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserUpdateResponse} obj Optional instance to populate.
   * @return {module:model/UserUpdateResponse} The populated <code>UserUpdateResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UserUpdateResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('account'))
        obj.account = ApiClient.convertToType(data['account'], Object);
      if (data.hasOwnProperty('messages'))
        obj.messages = ApiClient.convertToType(data['messages'], Object);
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
UserUpdateResponse.prototype.status = undefined;

/**
 * @member {Object} account
 */
UserUpdateResponse.prototype.account = undefined;

/**
 * @member {Object} messages
 */
UserUpdateResponse.prototype.messages = undefined;

